<template lang="pug">
v-content
    v-container(fluid)
      v-flex
        v-card
          v-toolbar(color='white')
            v-toolbar-title(v-model="title") {{ title }}
            v-spacer
          v-divider
          div
            v-card-title
              v-row
                v-col(cols="12" md="3" sm="12")
                  v-text-field(
                    v-model="search",
                    append-icon="mdi-magnify",
                    label="Search Fullname",
                    hint="Cari berdasarkan nama yang telah didaftarkan"
                    persistent-hint,
                    single-line,
                    ref="searchInput"
                  )
                v-divider(class="mx-1" inset vertical)
                v-col(cols="12" md="3" sm="12")
                  v-autocomplete(
                    v-model="selectedOption",
                    :items="optionsAutoComplete",
                    item-text="name"
                    item-value="_id"
                    :loading="loading",
                    :search-input.sync="searchAutoComplete",
                    label="Search for PJS",
                    hint="Cari berdasarkan nama yang terdaftar di iPermit",
                    persistent-hint,
                    ref="selectOptions"
                  )
                    template(v-slot:item="{item}")
                      v-list-item-content
                        v-list-item-title {{ item.name }}
                        v-list-item-subtitle
                          div(class="my-2") {{ item.nik }}
                          div(class="d-flex flex-wrap" v-if="'companies' in item && Array.isArray(item.companies)")
                            v-chip(style="font-size: 12px; height: unset; color: #ffffff;" v-for="(comp, idx) in item.companies" :key="'companies_'+idx" color="red" class="font-weight-bold me-1 mb-1") {{ comp }}
                v-col(cols="12" md="3" sm= "12")
                  v-menu(
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="dates"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  )
                    template(v-slot:activator="{ on }")
                      v-text-field(
                        v-model="dateRangeText"
                        label="Leave date range"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                      )
                    v-card
                      v-date-picker(
                        v-model="dates"
                        range
                        scrollable
                        no-title
                      )
                      v-card-actions
                          v-spacer
                          v-btn(text @click="menu = false") Cancel
                          v-btn(color="primary" @click="updateDateRange()") OK
                v-col(cols="12" md="2" sm= "12")
                  v-btn.mt-3.btn-primary(block="" color="primary" @click="confirmed('storePjs')") Submit

            v-data-table.elevation-1(
              :headers="headers"
              :items="items"
              :server-items-length="totalItems"
              :loading="loading"
              :options.sync="options"
              :items-per-page="options.itemsPerPage"
              :sort-by="options.sortBy"
              :sort-desc="options.sortDesc"
              multi-sort
              item-key="_id"
              @update:options="fetchData"
            )
              template(v-slot:item.department="{ item }")
                template(v-if="Array.isArray(item.department)")
                  template(v-for="dept in item.department")
                      v-chip(label small style="width:200px;margin:3px;justify-content:space-evenly" text-color="black") {{ dept }}
                v-chip(v-else label small style="width:200px;margin:3px;justify-content:space-evenly" text-color="black") {{ item.department }}
              template(v-slot:item.leaveUser.date_leave_start="{ item }")
                | {{ formatDate(item.leaveUser.date_leave_start) }}
              template(v-slot:item.leaveUser.date_leave_end="{ item }")
                | {{ formatDate(item.leaveUser.date_leave_end) }}
              template(v-slot:item.actions="{ item }")
                v-icon(small class='mr-2' title='Delete' color="primary" @click="show(item)") edit
                v-icon(small class='mr-2' title='Delete' color="red" @click="setDeleteId(item._id, item.name)") delete

        v-dialog(v-model="showDialog" width="640")
          v-card
            v-card-title(class="text-h5 grey lighten-2") Edit PJS
            v-card-text(class="pt-5")
              v-row
                v-col(cols="12" md="6" sm="12")
                  v-text-field(v-model="showName" mb-0 label="Nama PJS" outlined disabled hide-details)
                v-col(cols="12" md="6" sm= "12")
                    v-menu(
                      ref="showMenu"
                      v-model="showMenu"
                      :close-on-content-click="false"
                      :return-value.sync="showDate"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    )
                      template(v-slot:activator="{ on }")
                        v-text-field(
                          v-model="showDateRangeText"
                          label="Leave date range"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-on="on"
                        )
                      v-card
                        v-date-picker(
                          v-model="showDate"
                          range
                          scrollable
                          no-title
                        )
                        v-card-actions
                          v-spacer
                          v-btn(text @click="showMenu = false") Cancel
                          v-btn(color="primary" @click="updateDateRange('show')") OK
            v-divider
            v-card-actions
              v-spacer
              v-btn(color="primary" class="text-warning" text @click="showDialog = false")
                | Cancel
              v-btn(color="primary" text @click="editDate()")
                | Save
        
        Confirm(ref="confirmComponent" actionFor="confirm" :dialogConfirm="confirmation")
          template(v-slot:body)
            h3(class="title-alert") Konfirmasi Penyimpanan
            div(class="word-wrap") Apakah Anda yakin ingin menyimpan data ini?
            div Pastikan informasi sudah benar.
          template(v-slot:action)
            v-btn(class="mb-8 confirm-action-default" @click="confirmation = false") Batal
            v-btn(class="mb-8 confirm-action-success" @click="confirmed(methodConfirmed, 'ok')") Simpan

        Confirm(ref="warningComponent" actionFor="warning" :dialogConfirm="confirmationWarning")
          template(v-slot:body)
            h3(class="title-alert") Konfirmasi Penghapusan
            div(class="word-wrap") Anda yakin ingin menghapus PJS 
              b {{ confirmationWarningName }}
              |?
            div Tindakan ini bersifat permanen dan tidak bisa diurungkan.
          template(v-slot:action)
            v-btn(class="mb-8 confirm-action-default" @click="confirmationWarning = false") Batal
            v-btn(class="mb-8 confirm-action-danger" @click="confirmedWarning(methodConfirmed, 'ok')") Ya, Hapus
</template>

<script>
import config from "../config/index.json";
import { mapState } from "vuex";
import axios from "axios";
import { debounce } from 'lodash';
import moment from "moment";
import Confirm from "../components/partials/Confirm.vue";

export default {
  name: "InfoCuti",
  components: { Confirm },
  data () {
    return {
      // other
      config: config.default,
      title: 'Info Cuti',
      confirmation: false,
      confirmationWarning: false,
      confirmationWarningName: '',
      methodConfirmed: '',
      deleteIdPjs: null,

      showDialog: false,
      showMenu: false,
      showName: '',
      showDate: [],
      showId: null,

      // data table
      headers: [
        { text: 'Fullname', value: 'name' },
        { text: 'Departmen', value: 'department' },
        { text: 'Start Date', value: 'leaveUser.date_leave_start' },
        { text: 'End Date', value: 'leaveUser.date_leave_end' },
        { text: 'Action', value: 'actions', sortable: false }
      ],
      items: [],
      totalItems: 0,
      loading: false,
      search: '',
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['name'],
        sortDesc: [false],
      },

      // autocomplete
      selectedOption: null,
      optionsAutoComplete: [],
      searchAutoComplete: '',

      // datepicker
      menu: false,
      dates: [],
    }
  },
  computed: {
    ...mapState(["API_URL", "dataUsers"]),
    dateRangeText () {
      return this.dates.join(' s/d ')
    },
    showDateRangeText () {
      return this.showDate.join(' s/d ')
    },
  },
  methods: {
    formatDate (date) {
      return moment(date).format("YYYY-MM-DD")
    },
    updateDateRange(actionFrom = 'primary') {
      if (actionFrom === 'primary') {
        const start = moment(this.dates[0]);
        const end = moment(this.dates[1]);
        let setDate = this.dates;
        if (start.isAfter(end)) setDate = [this.formatDate(end), this.formatDate(start)];
        this.$refs.menu.save(setDate);
      } else {
        const start = moment(this.showDate[0]);
        const end = moment(this.showDate[1]);
        let setDate = this.showDate;
        if (start.isAfter(end)) setDate = [this.formatDate(end), this.formatDate(start)];
        this.$refs.showMenu.save(setDate);
      }
    },
    confirmed(methodConfirmed, action = "no") {
      if (action === 'ok') {
        this[methodConfirmed]();
        this.confirmation = false;
      } else {
        this.confirmation = true;
        this.methodConfirmed = methodConfirmed;
      }
    },
    confirmedWarning(methodConfirmed, action = "no") {
      if (action === 'ok') {
        this[methodConfirmed]();
        this.confirmationWarning = false;
      } else {
        this.confirmationWarning = true;
        this.methodConfirmed = methodConfirmed;
      }
    },
    async fetchData() {
      this.loading = true;

      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      const search = this.search;

      try {
        const response = await axios.get(this.API_URL+'/v1/employees/leaveInfo', {
          params: {
            page,
            itemsPerPage,
            sortBy: sortBy,
            sortDesc: sortDesc,
            search,
          },
          headers: {"Authorization": `Bearer ${this.$store.state.token}`}
        });

        this.items = response.data.data.items;
        this.totalItems = response.data.data.totalItems;
      } catch (error) {
        console.error('Failed to fetch data:', error);
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.optionsAutoComplete = [];
      this.dates = [];

      this.showName = '';
      this.showId = null;
      this.showDate = [];
    },
    async fetchOptions() {
      if (!this.searchAutoComplete) {
        this.optionsAutoComplete = [];
        return;
      }

      this.loading = true;
      await axios
        .get(this.API_URL+'/v1/employees/findBaseCompany', {
          params: {
            search: this.searchAutoComplete
          },
          headers: {"Authorization": `Bearer ${this.$store.state.token}`}
        })
        .then(response => {
          this.optionsAutoComplete = response.data.data;
        })
        .catch(error => {
          console.error('Error fetching optionsAutoComplete:', error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async storePjs() {
      if (!this.selectedOption || this.dates.length !== 2) {
        return this.$snackbar.showMessage({ message: 'Inputan kurang lengkap', color: 'red' });
      }
      
      await axios
        .post(
          this.API_URL+'/v1/employees/storePjs', 
          [{
            dates: this.dates,
            pjs: this.selectedOption
          }],
          {
            headers: {"Authorization": `Bearer ${this.$store.state.token}`
          }
        })
        .then(() => {
          this.resetForm();
          this.fetchData();
        })
        .catch(error => {
          console.error('Error store PJS:', error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async deletePjs() {
      await axios
        .post(
          this.API_URL+'/v1/employees/deletePjs', 
          {
            id: this.deleteIdPjs,
          },
          {
            headers: {"Authorization": `Bearer ${this.$store.state.token}`
          }
        })
        .then(() => {
          this.fetchData();
        })
        .catch(error => {
          console.error('Error store PJS:', error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setDeleteId(id, name) {
      this.deleteIdPjs = id;
      this.confirmationWarningName = name;
      this.confirmedWarning('deletePjs');
    },
    async getDateLeave() {
      if (this.dataUsers.location[0] !== 'HO') return false;

      this.loading = true;
      await axios
        .get(this.API_URL+'/v1/employees/getDateLeaveUser', {
          headers: {"Authorization": `Bearer ${this.$store.state.token}`}
        })
        .then(response => {
          const data = response.data.data;
          if (!data || Object.keys(data).length === 0) return false;
          this.dates = [data.startDate, data.endDate];
        })
        .catch(error => {
          console.error('Error fetching optionsAutoComplete:', error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async show(obj) {
      this.showName = obj.name;
      this.showId = obj._id;
      this.showDate = [this.formatDate(obj.leaveUser.date_leave_start), this.formatDate(obj.leaveUser.date_leave_end)];
      this.showDialog = true;
    },
    async editDate() {
      if (!this.showId || this.showDate.length !== 2) {
        return this.$snackbar.showMessage({ message: 'Inputan kurang lengkap', color: 'red' });
      }
      
      await axios
        .post(
          this.API_URL+'/v1/employees/updatePjs', 
          {
            id: this.showId,
            dates: this.showDate
          },
          {
            headers: {"Authorization": `Bearer ${this.$store.state.token}`
          }
        })
        .then(() => {
          this.showDialog = false;
          this.resetForm();
          this.fetchData();
        })
        .catch(error => {
          console.error('Error store PJS:', error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  mounted() {
    this.getDateLeave()
  },
  watch: {
    options: {
      handler: debounce(function() {
        this.fetchData();
      }, 500),
      deep: true,
    },
    search: {
      handler: debounce(async function() {
        await this.fetchData();
        this.$nextTick(() => {
          this.$refs.searchInput.focus();
        });
      }, 500), // delay in milliseconds
      immediate: true
    },
    searchAutoComplete: async function(val) {
      if (!val || val?.length < 3) {
        this.optionsAutoComplete = [];
        return;
      }
      await this.fetchOptions();
      this.$nextTick(() => {
        this.$refs.selectOptions.focus();
      })
    }
  },
};
</script>